import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CHARACTER_NAMES } from "@binogi-livequiz/shared";
import Wordmark from "../components/Wordmark";
import { CharacterImage } from "../components/CharacterImage";

/**
 * Visual gallery of every assignable character, in popularity order — the
 * order they get picked as students join. Useful for previewing the cast
 * outside a live session.
 */
export default function Characters() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <main className="min-h-full px-4 md:px-6 py-6 md:py-10 max-w-2xl mx-auto">
      <header className="flex items-center justify-between mb-8">
        <Wordmark size="md" />
        <button
          type="button"
          onClick={() => navigate("/")}
          className="text-sm text-white/60 hover:text-white"
        >
          ← {t("common.home")}
        </button>
      </header>

      <div className="text-center mb-6">
        <h1 className="text-2xl md:text-3xl font-bold">
          {t("characters.heading")}
        </h1>
        <p className="mt-2 text-white/60 text-sm">
          {t("characters.lead", { count: CHARACTER_NAMES.length })}
        </p>
      </div>

      <ul className="space-y-2">
        {CHARACTER_NAMES.map((name, i) => (
          <li
            key={name}
            className="flex items-center gap-3 px-3 py-2 bg-brand-ink2 rounded-xl"
          >
            <span className="w-6 text-xs font-semibold text-white/40 tabular-nums">
              {i + 1}
            </span>
            <CharacterImage name={name} size={56} className="flex-shrink-0" />
            <span className="font-semibold text-lg">{name}</span>
          </li>
        ))}
      </ul>
    </main>
  );
}
